
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Skeleton from '@mui/material/Skeleton';
import CallMadeIcon from '@mui/icons-material/CallMade';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

import { Labeled } from '../../../_Components';

const styles = {
    root: {
        margin: 'auto',
    },
    paper: {
        width: 200,
        height: 230,
        overflow: 'auto',
    },
    icon: {
        top: 133,
        position: 'relative',
        padding: 5
    }
}

const AgentsListLeft = ({classes, items, handleToggle}) =>{
    // let record = {search: {}};
    // const search = '';
    return(
        <Paper className={classes.paper} style={{width: '100%'}}>
            {/* <TextInput record={record} source="searchLeft" label=" " className={classes.searchInput}/> */}
            <List dense component="div" role="list">
                {items.map(value => {
                    const labelId = `transfer-list-item-${value.AgentID}-label`;
                    // if(value.Name.toLowerCase().trim().search(search ? search.toLowerCase().trim() : '')>=0){
                        return (
                            <ListItem key={value.login} role="listitem" button onClick={handleToggle(value)} style={{padding: 5}}>
                                {value.Type === 'Inbound'&&
                                    <ListItemIcon>
                                        <CallReceivedIcon style={{color: '#59af50'}} />
                                    </ListItemIcon>
                                }
                                {value.Type === 'Outbound'&&
                                    <ListItemIcon>
                                        <CallMadeIcon style={{color: '#55bdd4'}}/>
                                    </ListItemIcon>
                                }
                              <ListItemText id={labelId} primary={`${value.login} ${value.fullname}`} style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}} />
                            </ListItem>
                        )
                    // };
                })}
                <ListItem />
            </List>
        </Paper>
    )
};

 const AgentsListRight = ({classes, items, handleToggle}) =>{
    // let record = {search: {}};
    // const search = '';
    return(
        <Paper className={classes.paper} style={{width: '100%'}}>
            {/* <TextInput record={record} source="searchRight" label=" " className={classes.searchInput}/> */}
            <List dense component="div" role="list">
                {items.map(value => {
                    const labelId = `transfer-list-item-${value.AgentID}-label`;
                    // if(value.Name.toLowerCase().trim().search(search ? search.toLowerCase().trim() : '')>=0){
                        return (
                            <ListItem key={value.login} role="listitem" button onClick={handleToggle(value)} style={{padding: 5}}>
                                {value.Type === 'Inbound'&&
                                    <ListItemIcon>
                                        <CallReceivedIcon style={{color: '#59af50'}} />
                                    </ListItemIcon>
                                }
                                {value.Type === 'Outbound'&&
                                    <ListItemIcon>
                                        <CallMadeIcon style={{color: '#55bdd4'}}/>
                                    </ListItemIcon>
                                }
                              <ListItemText id={labelId} primary={`${value.login} ${value.fullname}`} style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}} />
                            </ListItem>
                        )
                    // };
                })}
                <ListItem />
            </List>
        </Paper>
    )
};

const Agents = ({classes, source, left, right, handleToggle, ...props}) => (
    <div className={props.className}>
        {(left && right) ?
            <div style={{display: 'flex'}}>
                <Labeled label="Доступные операторы">
                    <Grid container spacing={0} justify="center" alignItems="center" className={classes.root}>
                        <Grid item style={{width: '100%'}}><AgentsListLeft items={left} classes={classes} handleToggle={handleToggle}/></Grid>
                    </Grid>
                </Labeled>
                <SyncAltIcon className={classes.icon}/>
                <Labeled label="Включены в очередь">
                    <Grid container spacing={0} justify="center" alignItems="center" className={classes.root}>
                        <Grid item style={{width: '100%'}}><AgentsListRight items={right} classes={classes} handleToggle={handleToggle}/></Grid>
                    </Grid>
                </Labeled>
            </div>
        : 
            <div style={{display: 'flex'}}>
                <div style={{padding: '16px 0px 0px 0px', width: '100%'}}>
                    <Skeleton variant="text" />
                    <Skeleton variant="rect" height={242} style={{padding: '0 20px'}}/>
                </div>
                <SyncAltIcon className={classes.icon}/>
                <div style={{padding: '16px 0px 0px 0px', width: '100%'}}>
                    <Skeleton variant="text" />
                    <Skeleton variant="rect" height={242} style={{padding: '0 20px'}}/>
                </div>
            </div>
        }
    </div>
)

export default withStyles(styles)(Agents);